webpackJsonp(["pages.projects.milestones.index","pages.milestones.shared"],{

/***/ "./pages/milestones/shared/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: ./vue_shared/translate.js
var translate = __webpack_require__("./vue_shared/translate.js");

// EXTERNAL MODULE: ./lib/utils/axios_utils.js
var axios_utils = __webpack_require__("./lib/utils/axios_utils.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./vue_shared/components/modal.vue + 2 modules
var modal = __webpack_require__("./vue_shared/components/modal.vue");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// CONCATENATED MODULE: ./pages/milestones/shared/event_hub.js


/* harmony default export */ var event_hub = (new vue_esm["a" /* default */]());
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/milestones/shared/components/delete_milestone_modal.vue









/* harmony default export */ var delete_milestone_modal = ({
  components: {
    modal: modal["a" /* default */]
  },
  props: {
    issueCount: {
      type: Number,
      required: true
    },
    mergeRequestCount: {
      type: Number,
      required: true
    },
    milestoneId: {
      type: Number,
      required: true
    },
    milestoneTitle: {
      type: String,
      required: true
    },
    milestoneUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    text: function text() {
      var milestoneTitle = Object(locale["f" /* sprintf */])('<strong>%{milestoneTitle}</strong>', { milestoneTitle: this.milestoneTitle });

      if (this.issueCount === 0 && this.mergeRequestCount === 0) {
        return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Milestones|\nYou\u2019re about to permanently delete the milestone %{milestoneTitle} from this project.\n%{milestoneTitle} is not currently used in any issues or merge requests.'), {
          milestoneTitle: milestoneTitle
        }, false);
      }

      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Milestones|\nYou\u2019re about to permanently delete the milestone %{milestoneTitle} from this project and remove it from %{issuesWithCount} and %{mergeRequestsWithCount}.\nOnce deleted, it cannot be undone or recovered.'), {
        milestoneTitle: milestoneTitle,
        issuesWithCount: Object(locale["d" /* n__ */])('%d issue', '%d issues', this.issueCount),
        mergeRequestsWithCount: Object(locale["d" /* n__ */])('%d merge request', '%d merge requests', this.mergeRequestCount)
      }, false);
    },
    title: function title() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Milestones|Delete milestone %{milestoneTitle}?'), { milestoneTitle: this.milestoneTitle });
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      event_hub.$emit('deleteMilestoneModal.requestStarted', this.milestoneUrl);

      return axios_utils["a" /* default */].delete(this.milestoneUrl).then(function (response) {
        event_hub.$emit('deleteMilestoneModal.requestFinished', { milestoneUrl: _this.milestoneUrl, successful: true });

        // follow the rediect to milestones overview page
        Object(url_utility["d" /* redirectTo */])(response.request.responseURL);
      }).catch(function (error) {
        event_hub.$emit('deleteMilestoneModal.requestFinished', { milestoneUrl: _this.milestoneUrl, successful: false });

        if (error.response && error.response.status === 404) {
          Object(flash["a" /* default */])(Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Milestones|Milestone %{milestoneTitle} was not found'), { milestoneTitle: _this.milestoneTitle }));
        } else {
          Object(flash["a" /* default */])(Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Milestones|Failed to delete milestone %{milestoneTitle}'), { milestoneTitle: _this.milestoneTitle }));
        }
        throw error;
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48a8f136","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/milestones/shared/components/delete_milestone_modal.vue
var delete_milestone_modal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"id":"delete-milestone-modal","title":_vm.title,"text":_vm.text,"kind":"danger","primary-button-label":_vm.s__('Milestones|Delete milestone')},on:{"submit":_vm.onSubmit},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('p',{domProps:{"innerHTML":_vm._s(props.text)}})]}}])})}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./pages/milestones/shared/components/delete_milestone_modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  delete_milestone_modal,
  delete_milestone_modal_render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_delete_milestone_modal = (Component.exports);

// CONCATENATED MODULE: ./pages/milestones/shared/delete_milestone_modal_init.js





/* harmony default export */ var delete_milestone_modal_init = (function () {
  vue_esm["a" /* default */].use(translate["a" /* default */]);

  var onRequestFinished = function onRequestFinished(_ref) {
    var milestoneUrl = _ref.milestoneUrl,
        successful = _ref.successful;

    var button = document.querySelector('.js-delete-milestone-button[data-milestone-url="' + milestoneUrl + '"]');

    if (!successful) {
      button.removeAttribute('disabled');
    }

    button.querySelector('.js-loading-icon').classList.add('hidden');
  };

  var onRequestStarted = function onRequestStarted(milestoneUrl) {
    var button = document.querySelector('.js-delete-milestone-button[data-milestone-url="' + milestoneUrl + '"]');
    button.setAttribute('disabled', '');
    button.querySelector('.js-loading-icon').classList.remove('hidden');
    event_hub.$once('deleteMilestoneModal.requestFinished', onRequestFinished);
  };

  var onDeleteButtonClick = function onDeleteButtonClick(event) {
    var button = event.currentTarget;
    var modalProps = {
      milestoneId: parseInt(button.dataset.milestoneId, 10),
      milestoneTitle: button.dataset.milestoneTitle,
      milestoneUrl: button.dataset.milestoneUrl,
      issueCount: parseInt(button.dataset.milestoneIssueCount, 10),
      mergeRequestCount: parseInt(button.dataset.milestoneMergeRequestCount, 10)
    };
    event_hub.$once('deleteMilestoneModal.requestStarted', onRequestStarted);
    event_hub.$emit('deleteMilestoneModal.props', modalProps);
  };

  var deleteMilestoneButtons = document.querySelectorAll('.js-delete-milestone-button');
  deleteMilestoneButtons.forEach(function (button) {
    button.addEventListener('click', onDeleteButtonClick);
  });

  event_hub.$once('deleteMilestoneModal.mounted', function () {
    deleteMilestoneButtons.forEach(function (button) {
      button.removeAttribute('disabled');
    });
  });

  return new vue_esm["a" /* default */]({
    el: '#delete-milestone-modal',
    components: {
      deleteMilestoneModal: components_delete_milestone_modal
    },
    data: function data() {
      return {
        modalProps: {
          milestoneId: -1,
          milestoneTitle: '',
          milestoneUrl: '',
          issueCount: -1,
          mergeRequestCount: -1
        }
      };
    },
    mounted: function mounted() {
      event_hub.$on('deleteMilestoneModal.props', this.setModalProps);
      event_hub.$emit('deleteMilestoneModal.mounted');
    },
    beforeDestroy: function beforeDestroy() {
      event_hub.$off('deleteMilestoneModal.props', this.setModalProps);
    },

    methods: {
      setModalProps: function setModalProps(modalProps) {
        this.modalProps = modalProps;
      }
    },
    render: function render(createElement) {
      return createElement(components_delete_milestone_modal, {
        props: this.modalProps
      });
    }
  });
});
// EXTERNAL MODULE: ./vue_shared/components/gl_modal.vue + 2 modules
var gl_modal = __webpack_require__("./vue_shared/components/gl_modal.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/milestones/shared/components/promote_milestone_modal.vue








/* harmony default export */ var promote_milestone_modal = ({
  components: {
    GlModal: gl_modal["a" /* default */]
  },
  props: {
    milestoneTitle: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    groupName: {
      type: String,
      required: true
    }
  },
  computed: {
    title: function title() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Milestones|Promote %{milestoneTitle} to group milestone?'), { milestoneTitle: this.milestoneTitle });
    },
    text: function text() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Milestones|Promoting %{milestoneTitle} will make it available for all projects inside %{groupName}.\n      Existing project milestones with the same title will be merged.\n      This action cannot be reversed.'), { milestoneTitle: this.milestoneTitle, groupName: this.groupName });
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      event_hub.$emit('promoteMilestoneModal.requestStarted', this.url);
      return axios_utils["a" /* default */].post(this.url, { params: { format: 'json' } }).then(function (response) {
        event_hub.$emit('promoteMilestoneModal.requestFinished', { milestoneUrl: _this.url, successful: true });
        Object(url_utility["g" /* visitUrl */])(response.data.url);
      }).catch(function (error) {
        event_hub.$emit('promoteMilestoneModal.requestFinished', { milestoneUrl: _this.url, successful: false });
        Object(flash["a" /* default */])(error);
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c645938e","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/milestones/shared/components/promote_milestone_modal.vue
var promote_milestone_modal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-modal',{attrs:{"id":"promote-milestone-modal","footer-primary-button-variant":"warning","footer-primary-button-text":_vm.s__('Milestones|Promote Milestone')},on:{"submit":_vm.onSubmit}},[_c('template',{slot:"title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],2)}
var promote_milestone_modal_staticRenderFns = []

// CONCATENATED MODULE: ./pages/milestones/shared/components/promote_milestone_modal.vue
/* script */


/* template */

/* template functional */
var promote_milestone_modal___vue_template_functional__ = false
/* styles */
var promote_milestone_modal___vue_styles__ = null
/* scopeId */
var promote_milestone_modal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var promote_milestone_modal___vue_module_identifier__ = null

var promote_milestone_modal_Component = Object(component_normalizer["a" /* default */])(
  promote_milestone_modal,
  promote_milestone_modal_render,
  promote_milestone_modal_staticRenderFns,
  promote_milestone_modal___vue_template_functional__,
  promote_milestone_modal___vue_styles__,
  promote_milestone_modal___vue_scopeId__,
  promote_milestone_modal___vue_module_identifier__
)

/* harmony default export */ var components_promote_milestone_modal = (promote_milestone_modal_Component.exports);

// CONCATENATED MODULE: ./pages/milestones/shared/promote_milestone_modal_init.js





vue_esm["a" /* default */].use(translate["a" /* default */]);

/* harmony default export */ var promote_milestone_modal_init = (function () {
  var onRequestFinished = function onRequestFinished(_ref) {
    var milestoneUrl = _ref.milestoneUrl,
        successful = _ref.successful;

    var button = document.querySelector('.js-promote-project-milestone-button[data-url="' + milestoneUrl + '"]');

    if (!successful) {
      button.removeAttribute('disabled');
    }
  };

  var onRequestStarted = function onRequestStarted(milestoneUrl) {
    var button = document.querySelector('.js-promote-project-milestone-button[data-url="' + milestoneUrl + '"]');
    button.setAttribute('disabled', '');
    event_hub.$once('promoteMilestoneModal.requestFinished', onRequestFinished);
  };

  var onDeleteButtonClick = function onDeleteButtonClick(event) {
    var button = event.currentTarget;
    var modalProps = {
      milestoneTitle: button.dataset.milestoneTitle,
      url: button.dataset.url,
      groupName: button.dataset.groupName
    };
    event_hub.$once('promoteMilestoneModal.requestStarted', onRequestStarted);
    event_hub.$emit('promoteMilestoneModal.props', modalProps);
  };

  var promoteMilestoneButtons = document.querySelectorAll('.js-promote-project-milestone-button');
  promoteMilestoneButtons.forEach(function (button) {
    button.addEventListener('click', onDeleteButtonClick);
  });

  event_hub.$once('promoteMilestoneModal.mounted', function () {
    promoteMilestoneButtons.forEach(function (button) {
      button.removeAttribute('disabled');
    });
  });

  var promoteMilestoneModal = document.getElementById('promote-milestone-modal');
  var promoteMilestoneComponent = void 0;

  if (promoteMilestoneModal) {
    promoteMilestoneComponent = new vue_esm["a" /* default */]({
      el: promoteMilestoneModal,
      components: {
        PromoteMilestoneModal: components_promote_milestone_modal
      },
      data: function data() {
        return {
          modalProps: {
            milestoneTitle: '',
            groupName: '',
            url: ''
          }
        };
      },
      mounted: function mounted() {
        event_hub.$on('promoteMilestoneModal.props', this.setModalProps);
        event_hub.$emit('promoteMilestoneModal.mounted');
      },
      beforeDestroy: function beforeDestroy() {
        event_hub.$off('promoteMilestoneModal.props', this.setModalProps);
      },

      methods: {
        setModalProps: function setModalProps(modalProps) {
          this.modalProps = modalProps;
        }
      },
      render: function render(createElement) {
        return createElement('promote-milestone-modal', {
          props: this.modalProps
        });
      }
    });
  }

  return promoteMilestoneComponent;
});
// CONCATENATED MODULE: ./pages/milestones/shared/index.js



/* harmony default export */ var shared = __webpack_exports__["default"] = (function () {
  delete_milestone_modal_init();
  promote_milestone_modal_init();
});

/***/ }),

/***/ "./pages/projects/milestones/index/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_milestones_shared__ = __webpack_require__("./pages/milestones/shared/index.js");


document.addEventListener('DOMContentLoaded', __WEBPACK_IMPORTED_MODULE_0__pages_milestones_shared__["default"]);

/***/ }),

/***/ "./vue_shared/components/gl_modal.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/gl_modal.vue

var buttonVariants = ['danger', 'primary', 'success', 'warning'];

/* harmony default export */ var gl_modal = ({
  name: 'GlModal',

  props: {
    id: {
      type: String,
      required: false,
      default: null
    },
    headerTitleText: {
      type: String,
      required: false,
      default: ''
    },
    footerPrimaryButtonVariant: {
      type: String,
      required: false,
      default: 'primary',
      validator: function validator(value) {
        return buttonVariants.indexOf(value) !== -1;
      }
    },
    footerPrimaryButtonText: {
      type: String,
      required: false,
      default: ''
    }
  },

  methods: {
    emitCancel: function emitCancel(event) {
      this.$emit('cancel', event);
    },
    emitSubmit: function emitSubmit(event) {
      this.$emit('submit', event);
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-240a30a4","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/gl_modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":_vm.id,"tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":_vm.s__('Modal|Close')},on:{"click":function($event){_vm.emitCancel($event)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._t("title",[_vm._v("\n              "+_vm._s(_vm.headerTitleText)+"\n            ")])],2)])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{staticClass:"btn",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.emitCancel($event)}}},[_vm._v("\n            "+_vm._s(_vm.s__('Modal|Cancel'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn",class:("btn-" + _vm.footerPrimaryButtonVariant),attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.emitSubmit($event)}}},[_vm._v("\n            "+_vm._s(_vm.footerPrimaryButtonText)+"\n          ")])])],2)])])])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/gl_modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  gl_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_gl_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/modal.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/modal.vue
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable vue/require-default-prop */
/* harmony default export */ var modal = ({
  name: 'Modal',

  props: {
    id: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    kind: {
      type: String,
      required: false,
      default: 'primary'
    },
    modalDialogClass: {
      type: String,
      required: false,
      default: ''
    },
    closeKind: {
      type: String,
      required: false,
      default: 'default'
    },
    closeButtonLabel: {
      type: String,
      required: false,
      default: 'Cancel'
    },
    primaryButtonLabel: {
      type: String,
      required: false,
      default: ''
    },
    secondaryButtonLabel: {
      type: String,
      required: false,
      default: ''
    },
    submitDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    btnKindClass: function btnKindClass() {
      return _defineProperty({}, 'btn-' + this.kind, true);
    },
    btnCancelKindClass: function btnCancelKindClass() {
      return _defineProperty({}, 'btn-' + this.closeKind, true);
    }
  },

  methods: {
    emitCancel: function emitCancel(event) {
      this.$emit('cancel', event);
    },
    emitSubmit: function emitSubmit(event) {
      this.$emit('submit', event);
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e18618c","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-open"},[_c('div',{staticClass:"modal",class:_vm.id ? '' : 'show',attrs:{"id":_vm.id,"role":"dialog","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalDialogClass,attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('h4',{staticClass:"modal-title pull-left"},[_vm._v("\n              "+_vm._s(_vm.title)+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"close pull-right",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.emitCancel($event)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",[_c('p',[_vm._v(_vm._s(_vm.text))])],{text:_vm.text})],2),_vm._v(" "),(!_vm.hideFooter)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",class:_vm.btnCancelKindClass,attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.emitCancel($event)}}},[_vm._v("\n            "+_vm._s(_vm.closeButtonLabel)+"\n          ")]),_vm._v(" "),(_vm.secondaryButtonLabel)?_vm._t("secondary-button",[(_vm.secondaryButtonLabel)?_c('button',{staticClass:"btn",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n              "+_vm._s(_vm.secondaryButtonLabel)+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.primaryButtonLabel)?_c('button',{staticClass:"btn js-primary-button",class:_vm.btnKindClass,attrs:{"type":"button","disabled":_vm.submitDisabled,"data-dismiss":"modal"},on:{"click":function($event){_vm.emitSubmit($event)}}},[_vm._v("\n            "+_vm._s(_vm.primaryButtonLabel)+"\n          ")]):_vm._e()],2):_vm._e()])])]),_vm._v(" "),(!_vm.id)?_c('div',{staticClass:"modal-backdrop fade in"}):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_modal = __webpack_exports__["a"] = (Component.exports);


/***/ })

},["./pages/projects/milestones/index/index.js"]);


// WEBPACK FOOTER //
// pages.projects.milestones.index.5da78e7b3e87d8309412.bundle.js